import { CenteredContent } from '#/components/CenteredContent/CenteredContent';
import { H1 } from '#/components/Text/H1';
import { ForgotPasswordFormContainer } from '#/containers/ForgotPasswordFormContainer';
import { useI18n } from '#/i18n/hooks/useI18n';

type Props = {
  email: string | null | undefined;
};

export function ForgotPasswordPage({ email }: Props) {
  const { i18n } = useI18n();

  return (
    <CenteredContent>
      <H1 styleAs="h2">
        {
          /* TRANSLATORS: page title when user forgot their password */
          i18n('Reset Password')
        }
      </H1>

      <ForgotPasswordFormContainer
        analyticsTitle="[main] Forgot password page"
        usageContext="page"
        email={email}
      />
    </CenteredContent>
  );
}
